import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class MenuDeleteAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "MenuDelete";
    super(baseUrl);
  }


  getMenuDelete( sqId?: number){
    var request= new MenuDeleteListeRequest( sqId);
    
    return this.post("",request, false);
  }

}


export default new MenuDeleteAPI();
class MenuDeleteListeRequest {
  public sqId?: number;

 
  constructor(sqId?: number) {
   
      this.sqId = sqId;

      
  }
}
export { MenuDeleteListeRequest };